import graphql from "babel-plugin-relay/macro"

export const InitializeLogoutMutation = graphql`
  mutation SettingsModalQuery_initializeLogoutMutation {
    initializeLogout {
      ok
      token
      state
      error {
        code
        message
      }
    }
  }
`

export const LogoutMutation = graphql`
  mutation SettingsModalQuery_logoutMutation (
    $input: LogoutInput!
  ) {
    logout(input: $input) {
      ok
      error {
        code
        message
      }
    }
  }
`

export const SwitchAppMutation = graphql`
  mutation SettingsModalQuery_switchAppMutation (
    $input: SwitchAppForSessionInput!
  ) {
    switchAppForSession(input: $input) {
      ok
      error {
        code
        message
      }
    }
  }
`

export const UpdateAgentMutation = graphql`
  mutation SettingsModalQuery_updateAgentMutation (
    $input: UpdateAgentInput!
  ) {
    updateAgent(input: $input) {
      clientMutationId
      agent {
        wUserId
        etag
        email
        name
        icon
        user {
          wUserId
          email {
            email
            verified
          }
          firstName
          lastName
          profilePic
        }
      }
      channel {
        etag
        name
        wAppId
        wChannelId
        users {
          wUserId
          email {
            email
            verified
          }
          firstName
          lastName
          profilePic
          role
        }
        agents {
          _id
          etag
          email
          name
          icon
          role
          user {
            wUserId
            email {
              email
              verified
            }
            profilePic
            firstName
            lastName
            profilePic
            role
            initialRole
            channels {
              wChannelId
              integrationIcon
              integrationName
              name
            }
          }
        }
      }
      error {
        code
        message
      }
    }
  }
`

export const RemoveUserFromChannelMutation = graphql`
  mutation SettingsModalQuery_removeUserFromChannelMutation (
    $input: RemoveUserFromChannelInput!
  ) {
    removeUserFromChannel(input: $input) {
      clientMutationId
      error {
        code
        message
      }
      channel {
        etag
        name
        wAppId
        wChannelId
        agents {
          _id
          wUserId
          etag
          email
          name
          icon
          role
          user {
            wUserId
            email {
              email
              verified
            }
            profilePic
            firstName
            lastName
            profilePic
            role
            initialRole
            channels {
              wChannelId
              integrationIcon
              integrationName
              name
            }
          }
        }
      }
    }
  }
`

export const AddUserToChannelMutation = graphql`
  mutation SettingsModalQuery_addUserToChannelMutation (
    $input: AddUserToChannelInput!
  ) {
    addUserToChannel(input: $input) {
      clientMutationId
      channel {
        etag
        name
        wAppId
        wChannelId
        agents {
          wUserId
          etag
          email
          name
          icon
          role
          user {
            wUserId
            email {
              email
              verified
            }
            profilePic
            firstName
            lastName
            profilePic
            role
            initialRole
            channels {
              wChannelId
              integrationIcon
              integrationName
              name
            }
          }
        }
      }
    }
  }
`

export const UpdateUserMutation = graphql`
  mutation SettingsModalQuery_updateUserMutation (
    $input: UpdateUserInput!
  ) {
    updateUser(input: $input) {
      clientMutationId
      error {
        code
        message
      }
      user {
        wUserId
        connected
        email {
          email
          verified
        }
        profilePic
        firstName
        lastName
        profilePic
        role
        initialRole
        channels {
          wChannelId
          integrationIcon
          integrationName
          name
        }
      }
    }
  }
`


export const ConnectChannelMutation = graphql`
  mutation SettingsModalQuery_connectChannelMutation (
    $input: ConnectChannelInput!
  ) {
    connectChannel(input: $input) {
      clientMutationId
      error {
        code
        message
      }
      channel {
        wChannelId
        integrationIcon
        integrationName
        name
        connected
        etag
      }
    }
  }
`

export const DisconnectChannelMutation = graphql`
  mutation SettingsModalQuery_disconnectChannelMutation (
    $input: DisconnectChannelInput!
  ) {
    disconnectChannel(input: $input) {
      clientMutationId
      error {
        code
        message
      }
      channel {
        wChannelId
        integrationIcon
        integrationName
        name
        connected
        etag
      }
    }
  }
`

export const ActivateUserMutation = graphql`
  mutation SettingsModalQuery_activateUserMutation (
    $input: ActivateUserInput!
  ) {
    activateUser(input: $input) {
      clientMutationId
      error {
        code
        message
      }
      user {
        wUserId
        connected
        email {
          email
          verified
        }
        profilePic
        firstName
        lastName
        profilePic
        role
        initialRole
        channels {
          wChannelId
          integrationIcon
          integrationName
          name
        }
      }
    }
  }
`

export const CreateOutboundHookMutation = graphql`
  mutation SettingsModalQuery_createOutboundHookMutation (
    $input: CreateOutboundHookInput!
  ) {
    createOutboundHook(input: $input) {
      clientMutationId
      error {
        code
        subType
        message
      }
      hook {
        id
        _id
        wAppId
        name
        description
        code
        createdAt
        updatedAt
        etag
      }
    }
  }
`

export const UpdateOutboundHookMutation = graphql`
  mutation SettingsModalQuery_updateOutboundHookMutation (
    $input: UpdateOutboundHookInput!
  ) {
    updateOutboundHook(input: $input) {
      clientMutationId
      error {
        code
        subType
        message
      }
      hook {
        id
        _id
        wAppId
        name
        description
        code
        createdAt
        updatedAt
        etag
      }
    }
  }
`

export const DeleteOutboundHookMutation = graphql`
  mutation SettingsModalQuery_deleteOutboundHookMutation (
    $input: DeleteOutboundHookInput!
  ) {
    deleteOutboundHook(input: $input) {
      clientMutationId
      error {
        code
        subType
        message
      }
      hook {
        id
        _id
      }
    }
  }
`

export const SetChannelOutboundHooksMutation = graphql`
  mutation SettingsModalQuery_setChannelOutboundHooksMutation (
    $input: SetChannelOutboundHooksInput!
  ) {
    setChannelOutboundHooks(input: $input) {
      clientMutationId
      error {
        code
        subType
        message
      }
      channel {
        id
        wChannelId
        etag
        outboundHooks {
          id
          _id
          name
          description
          etag
        }
      }
    }
  }
`

export const UpdateOutboundHookConfigMutation = graphql`
  mutation SettingsModalQuery_updateOutboundHookConfigMutation (
    $input: UpdateOutboundHookConfigInput!
  ) {
    updateOutboundHookConfig(input: $input) {
      clientMutationId
      error {
        code
        subType
        message
      }
      app {
        wAppId
        outboundHookConfig {
          stepTimeoutMs
          chainTimeoutMs
          fetchAllowlistHosts
        }
      }
    }
  }
`

export const UpdateAppMutation = graphql`
  mutation SettingsModalQuery_UpdateAppMutation (
    $input: UpdateAppInput!
  ) {
    updateApp(input: $input) {
      clientMutationId
      error {
        code
        message
      }
      app {
        roleBasedAppConfig {
          MASK_EXTERNALID
        }
        defaultChannelConfig {
          roleBasedConfig {
            SEND_MESSAGE_ALL
            SEND_ATTACHMENT
            SEND_AUDIO
            TRANSFER_TO_UNASSOCIATED_FOLDERS
            # TODO: Enable this feature after we have filtering feature for extensions
            # USE_EXTENSION {
            #   extensionId
            #   roles
            # }
          }
          automation {
            INBOX_AGENT_INTERNAL_COMMENT
            INBOX_AGENT_MESSAGE
            INBOX_ASSIGN_AGENT
            INBOX_LIVECHAT_UPDATE
            MOVE_THREAD_FOLDER
          }
        }
      }
    }
  }
`

